<template>
  <div class="join3">
    <div class="text mt-3 mb-5">
      <p class="h4"><b>{{ $t("새 계정 생성") }}</b></p>
    </div>

    <!-- name -->
    <div class="row">
      <div class="col-sm-6 mb-3">
        <div class="form-floating">
          <p class="form-control-plaintext" id="first-name">
            {{ userChild.FIRST_NAME }}
          </p>
          <label for="first-name">
            <span class="required" aria-hidden="true">*</span>First name
          </label>
        </div>
        <div ref="FIRST_NAME" class="check red" role="alert">&nbsp;</div>
      </div>
      <div class="col-sm-6 mb-3">
        <div class="form-floating">
          <p class="form-control-plaintext" id="last-name">
            {{ userChild.LAST_NAME }}
          </p>
          <label for="last-name">
            <span class="required" aria-hidden="true">*</span>Last name
          </label>
        </div>
        <div ref="LAST_NAME" class="check red" role="alert">&nbsp;</div>
      </div>
    </div>

    <div class="col mb-3">
      <div class="input-group">
        <div class="form-floating flex-grow-1">
          <p class="form-control-plaintext" id="email">
            {{ userChild.EMAIL }}
          </p>
          <label for="email">
            <span class="required" aria-hidden="true">*</span>Email address
          </label>
        </div>
      </div>
      <div ref="EMAIL" class="check red" role="alert">&nbsp;</div>
    </div>

    <!-- user name(id) -->
    <div class="col mb-3">
      <div class="input-group">
        <div class="form-floating flex-grow-1">
          <p class="form-control-plaintext" id="user-id">
            {{ userChild.USER_ID }}
          </p>
          <label for="user-id">
            <span class="required" aria-hidden="true">*</span>Username
          </label>
        </div>
      </div>
      <div ref="USER_ID" class="check red" role="alert">&nbsp;</div>
    </div>

    <!-- buttons -->
    <div class="row">
      <div ref="ERRORS" class="check red" role="alert">&nbsp;</div>
    </div>
    <div class="row">
      <div class="col mt-3 mb-3">
        <button
          type="button"
          class="btn btn-outline-dark btn-lg rounded-pill w-100"
          @click="prev()"
        >
          Back
        </button>
      </div>
      <div class="col mt-3 mb-3">
        <button
          type="button"
          class="btn btn-dark btn-lg rounded-pill w-100"
          @click="submit()"
        >
          Submit
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import "@/assets/css/formLayout.css";
import { $axios, $error } from "@/dot-ui/index.js";

export default {
  props: ["user", "fromParams"],
  data() {
    return {
      userChild: {},
    };
  },
  created() {
    this.userChild = this.user;
  },
  methods: {
    // 이전화면으로 이동
    prev() {
      this.$emit("prev", this.userChild, "showJoin2");
    },
    // 다음화면으로 이동
    next() {
      this.$emit("changeData", this.userChild, "showJoin4");
    },
    // 회원가입 처리
    async submit() {
      // 클래스(.check) 폼 초기화
      $error.clearForm("check");

      let fromSiteNo = this.fromParams.s;
      let fromCompNo = this.fromParams.c;
      let url = "/user-app/v1/sites/" + fromSiteNo + "-" + fromCompNo + "/join";
      let param = this.userChild;
      let response = await $axios.post(url, param);

      if (response.status === 201) {
        this.next();
      } else {
        $error.showMessage(response, this);
        $error.focus(response);
      }
    },
  },
};
</script>
<style scroped>
</style>
